<template>
  <div class="ak-masthead__utility" :class="borderlessClass">
    <slot />
  </div>
</template>

<script>
import { defineComponent, inject, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-masthead-utility></ak-masthead-utility>
   */
  name: 'AkMastheadUtility',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description Controls whether the borderless class is applied to
     * the root of the component
     */
    borderless: {
      type: Boolean,
      default: false,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const parent = inject('akMasthead')

    /**
     * @returns {String}
     * @description Returns the borderless class for the component root
     */
    const borderlessClass = computed(() => {
      return props.borderless ? 'main-masthead__utility--borderless' : ''
    })

    /**
     * @description Closes the main navigations mobile navbar if it is open
     */
    const closeMenu = () => {
      try {
        parent.closeMenu()
      } catch (ex) {
        /* istanbul ignore next */
      }
    }

    return {
      borderlessClass,
      closeMenu,
    }
  },
})
</script>

<style lang="scss">
.ak-masthead__utility {
  display: flex;
  align-items: center;
  color: #fff;

  + .ak-masthead__utility {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
}
</style>
